import { render } from "./FiveColComponent.vue?vue&type=template&id=35ac81cc"
import script from "./FiveColComponent.vue?vue&type=script&lang=js"
export * from "./FiveColComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__